import '../styles/App.css';

const BackgroundWrapper = ({ children }) => {
  return <div className="background">{children}</div>;
};

export default BackgroundWrapper;